<template>
  <div>
    <div
      class="text-center"
      v-if="!dataLoaded"
    >
      <v-progress-circular
        class="mt-6"
        :size="50"
        color="primary"
        indeterminate
      />
    </div>

    <div
      class="mt-4"
      v-show="dataLoaded"
    >
      <TitleCard
        :is-show-mode="isShowMode"
        :is-process-mode="isProcessMode"
        :is-edit-mode="isEditMode"
        :disabled="invalid"
        :saveLoading="saveBtnLoading"
        :selected-item="peerReviewedPublication"
        @save="savePeerReviewedPublication"
      />

      <v-row class="mb-0 mt-3">
        <v-col
          cols="12"
          class="pt-0"
        >
          <v-list
            ref="workList"
            class="pr-2 pt-0 transparent overflow-auto"
          >
          </v-list>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { peerReviewedPublicationApi } from '@/api'
import TitleCard from '@/components/Works/elements/TitleCard'
import { PeerReviewedPublication } from '../../models'
import { workListHeight } from '@/mixins/workListHeight'
import { workMode } from '@/scripts/consts'

export default {
  name: 'PeerReviewedPublicationPage',

  metaInfo: {
    title: 'Статья рецензируемого издания'
  },

  components: {
    TitleCard
  },

  mixins: [workListHeight],

  async created() {
    this.isShowMode = this.$route.params.mode === workMode.Show
    this.isProcessMode = this.$route.params.mode === workMode.Process
    this.isEditMode = this.$route.params.mode === workMode.Edit
    await this.getPeerReviewedPublication()
    this.dataLoaded = true
  },

  data: () => ({
    peerReviewedPublication: new PeerReviewedPublication(),
    selectedItem: null,
    isShowMode: false,
    isEditMode: false,
    isProcessMode: false,
    saveBtnLoading: false,
    dataLoaded: false,
    peerReviewedPublicationInvalid: false
  }),

  computed: {
    invalid() {
      return this.peerReviewedPublicationInvalid
    }
  },

  methods: {
    async getPeerReviewedPublication() {
      try {
        if (this.$route.params?.id !== '0') {
          const data = await peerReviewedPublicationApi.get(this.$route.params?.id)
          this.peerReviewedPublication = data
            ? PeerReviewedPublication.buildFromAPI(data)
            : new PeerReviewedPublication()
        }
      } catch (e) {
        console.log(e)
      }
    },

    async savePeerReviewedPublication() {
      try {
        this.saveBtnLoading = true

        //if (!this.peerReviewedPublication.id) this.peerReviewedPublication.commonWork.workType = { id: 11, name: 'Статья рецензируемого издания' }

        const data = this.peerReviewedPublication.id
          ? await peerReviewedPublicationApi.update(this.peerReviewedPublication.getForAPI())
          : await peerReviewedPublicationApi.create(this.peerReviewedPublication.getForAPI())

        if (!this.peerReviewedPublication.id) this.$router.replace('/works/peerReviewedPublication/edit/' + data.id)

        this.peerReviewedPublication = data ? PeerReviewedPublication.buildFromAPI(data) : new PeerReviewedPublication()
        this.$toast.info('Успешно сохранено')
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, 'Ошибка сохранения')
      } finally {
        this.saveBtnLoading = false
      }
    },

    async updatePeerReviewedPublicationInvalid(val) {
      this.peerReviewedPublicationInvalid = val
    }
  },

  watch: {
    dataLoaded() {
      this.setWorkListHeight()
    }
  }
}
</script>

<style scoped></style>
